import { withInstall } from '@touchvue/utils'
import Scroll from './src/Scroll.vue'
import ScrollPoint from './src/ScrollPoint.vue'

export const ToScroll = withInstall(Scroll)
export const ToScrollPoint = withInstall(ScrollPoint)
export default ToScroll

export * from './src/scroll'
